import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { closeModal, openModal } from 'features/utilsSlice';
import useModalOpen from 'hooks/useModalOpen';
import TwoCards from './TwoCards';
import TransitionDialog from 'components/TransitionDialog';

const useStyles = makeStyles(theme => ({
  paper: {
    width: '100%',
    height: '100%',
  },

  paperFullWidth: {
    [theme.breakpoints.up('sm')]: {
      width: '100%',
      height: '100%',
    },

    [theme.breakpoints.up('lg')]: {
      width: '100%',
      height: '100%',
    },

    [theme.breakpoints.up('xl')]: {
      width: '100%',
      height: '100%',
    },
  },

  loginBox: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#ebedf2',
    padding: '20px 15px',
  },

  loginContent: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',

    [theme.breakpoints.up('md')]: {
      margin: '0 auto',
      width: 600,
      padding: '0 15px',
    },
  },

  loginButton: {
    height: 30,
    minWidth: 80,
    width: 80,
  },

  loginTitle: {
    fontSize: 16,
    lineHeight: '25px',
    opacity: 0.9,
  },
}));

const WhichAreYouDialog = () => {
  const [openForm, setOpenForm] = useState({ advertiser: false, influencer: false });
  const open = useModalOpen('Which Are You');
  const dispatch = useDispatch();
  const classes = useStyles();

  const handleClose = () => {
    dispatch(closeModal('Which Are You'));
    setOpenForm({ advertiser: false, influencer: false });
  };

  return (
    <TransitionDialog
      paperProps={{ className: classes.paper }}
      dialogStyles={classes.paperFullWidth}
      open={open}
      handleClose={handleClose}
      direction="left"
      desktopDirection="left"
      noCloseIcon
    >
      <div className={classes.loginBox}>
        <div className={classes.loginContent}>
          <h4 className={classes.loginTitle}>Already have an account?</h4>

          <Button
            className={classes.loginButton}
            onClick={() => dispatch(openModal({ name: 'Login' }))}
            color="primary"
            variant="contained"
          >
            Login
          </Button>
        </div>
      </div>

      <TwoCards
        openForm={openForm}
        setOpenForm={setOpenForm}
        contentOne="I want to promote myself with this post (buy a shoutout)"
        contentTwo="I want to promote my company’s product, service or brand"
        isDialog
      />
    </TransitionDialog>
  );
};

export default WhichAreYouDialog;
